import React, { useEffect, useRef } from 'react';

const SplineComponent = ({ 
  splineUrl, 
  splineCode, 
  title = 'Interactive 3D Experience',
  description = 'Experience our interactive 3D elements powered by Spline',
  className = '',
  height = '400px'
}) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (splineUrl && containerRef.current) {
      // Clear previous content
      containerRef.current.innerHTML = '';
      
      // Create iframe for Spline URL
      const iframe = document.createElement('iframe');
      iframe.src = splineUrl;
      iframe.frameBorder = '0';
      iframe.width = '100%';
      iframe.height = '100%';
      iframe.style.border = 'none';
      iframe.style.borderRadius = '0';
      iframe.style.background = 'transparent';
      iframe.title = title;
      
      containerRef.current.appendChild(iframe);
    } else if (splineCode && containerRef.current) {
      // Clear previous content
      containerRef.current.innerHTML = '';
      
      // Insert the embed code
      containerRef.current.innerHTML = splineCode;
    }
  }, [splineUrl, splineCode, title]);

  if (!splineUrl && !splineCode) {
    return (
      <div className={`flex items-center justify-center ${className}`} style={{ height }}>
        <div className="text-center p-8">
          <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">{title}</h3>
          <p className="text-gray-600 dark:text-gray-400 text-sm">{description}</p>
        </div>
      </div>
    );
  }

  return (
    <div 
      ref={containerRef}
      className={`overflow-hidden ${className}`}
      style={{ height }}
    />
  );
};

export default SplineComponent;
